import Common from '../../../Common';

const Group = class extends Common {
	async browse(userId: id) {
		return this.get(`/user/${userId}/acl/group`);
	}

	async delete(userId: id, groupId: id) {
		return this.doDelete(`/user/${userId}/acl/group/${groupId}`);
	}

	async create(userId: id, groupId: id) {
		return this.post(`/user/${userId}/acl/group/${groupId}`);
	}
}

export default Group;
